<template>
	<div
		class="tw-bg-white tw-text-gray-600 tw-w-full tw-rounded tw-py-1 tw-px-2 tw-text-left tw-relative tw-flex tw-items-center tw-space-x-2 tw-overflow-hidden"
	>
		<template v-if="loading">
			<i v-if="uploading" class="fas fa-spinner fa-spin tw-flex-none"></i>
			<i v-else class="fas fa-check tw-flex-none text-primary"></i>
		</template>
		<div
			class="tw-flex-1 tw-truncate"
		>{{document.originalName|| document.name }}({{(document.size / 1024).toFixed(2)}}KB)</div>
		<div class="tw-flex tw-items-center tw-space-x-2">
			<a v-if="download" :href="document.url" target="_blank" class="tw-text-base">
				<b-icon icon="download"></b-icon>
			</a>
			<button v-if="remove" type="button" @click="$emit('remove', $event)">
				<b-icon icon="x" class="tw-text-red-500 tw-text-2xl tw-flex-none"></b-icon>
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DocumentListItem',
	props: {
		loading: Boolean,
		uploading: Boolean,
		download: Boolean,
		remove: {
			type: Boolean,
			default: true
		},
		document: {
			type: [Object, File],
			required: true
		}
	}
}
</script>
